import { useContext } from 'react';

import { SharedAuthContext } from './SharedAuthContext';

export const useSharedAuth = () => {
  const context = useContext(SharedAuthContext);
  if (!context) {
    throw new Error('useSharedAuth must be used within a SharedAuthProvider');
  }
  return context;
};
